import { platformBrowser } from '@angular/platform-browser';
import { deepFreeze, elfHooks, enableElfProdMode } from '@ngneat/elf';
import { devTools } from '@ngneat/elf-devtools';

import { AppModule } from './app/app.module';
import { environment } from './environments/environment';

// Load TinyMCE script with API key from environment
if (environment.usePremiumTinyMceFeatures) {
  const script = document.createElement('script');
  script.src = `https://cdn.tiny.cloud/1/${environment.tinyMceApiKey}/tinymce/7/tinymce.min.js`;
  script.referrerPolicy = 'origin';
  document.head.append(script);
}

if (environment.production) {
  enableElfProdMode();
} else {
  devTools();
  elfHooks.registerPreStoreUpdate((_currentState, nextState) => {
    // eslint-disable-next-line @typescript-eslint/no-unsafe-return
    return deepFreeze(nextState);
  });
}

platformBrowser()
  .bootstrapModule(AppModule)
  .catch((err) => console.error(err));
